import React from "react";
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import { Grid, Icon, Popup } from 'semantic-ui-react'
import Progress from 'react-progressbar';
import "react-datepicker/dist/react-datepicker.css";
import ProgressCard from './../../Drive/cards/ProgressCard';
import DaysDifference from './../../Drive/cards/DaysDifference'
import BreadCrumbs from './../../Drive/cards/Breadcrumbs'
import ArrangementPane from './ArrangementPane';
import LoadingComponent from '../../../../common/LoadingComponent';
import momentDateAndTime from "../../../../../helpers/momentDateAndTime";
var moment = require('moment');

class WorkProgress extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
        this.parentRef = React.createRef();
        // this.onResize = this.onResize.bind(this);

    }

    async componentDidMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        let objValidation = Object.entries(this.props.selectedDataById).length === 0 && this.props.selectedDataById.constructor === Object
        if (objValidation) {
            await dispatch.initiatives.getActiveInitiativeDetailsById(this.props.match.params.initiativeId);
        }
        dispatch.initiatives.setTabName("Progress");
        let selectedDataById = this.props.selectedDataById;
        let payload = {};
        payload.organizationId = this.props.selectedOrganisation.id;
        payload.organizationId = this.props.selectedOrganisation.id;
        payload.initiativeId = this.props.match.params.initiativeId;
        if (selectedDataById && selectedDataById.category) {
            dispatch.initiatives.getPublishedContentDataAsync({ organizationId: selectedDataById.organizationId, category: selectedDataById.category });
        }
        if (payload.organizationId && !this.props.selectedDataById.activityNodes) {

            dispatch.initiatives.getAllActivities(payload);
        }
    }

    render() {
        let calculateProgress = ((this.props.selectedDataById.totalCompletedCount / this.props.selectedDataById.totalActivityCount) * 100).toFixed(0)
        let windowDimension = this.props.componentDesignerDimension;

        return (
            <div className="containerBox overflow-hide"
                ref={this.parentRef}
            // style={{ width: windowDimension.width ? windowDimension.width - 80 : 300 }}
            >
                <ArrangementPane {...this.props} />
                <BreadCrumbs {...this.props} />
                <LoadingComponent message="Fetching Initiative Details" active={this.props.loadingActiveDataById} />
                <LoadingComponent message="Fetching Initiative Activities" active={this.props.fetchingActivities} />
                <Grid className="initiative_overall_progress w_100" >
                    <Grid.Row style={{ padding: "10px 0 0 0" }}  >
                        <Grid.Column width={12} className="pad_0" onMouseEnter={() => dispatch.app.setHelpContext("Calendar Header")} >
                            <Icon name='calendar' />
                            <DaysDifference
                                startDate={this.props.selectedDataById.startDate}
                                endDate={this.props.selectedDataById.endDate}
                                totaldays={this.props.selectedDataById.totaldays}
                                timeZone={this.props.selectedDataById.timeZone}
                                activeTab={this.props.activeTab}
                                isInitiativeStarted={this.props.selectedDataById.actualStartDate ? true : false}
                                workingDays={this.props.selectedDataById.workingDays}
                            /> &nbsp; | &nbsp;&nbsp;

                                <Icon name='calendar alternate outline' />

                            {momentDateAndTime(this.props.selectedDataById.startDate)} to {momentDateAndTime(this.props.selectedDataById.endDate)} &nbsp;
                                {this.props.selectedDataById.actualStartDate && (moment(this.props.selectedDataById.startDate).format("MMM DD, YYYY HH:mm a") !== moment(this.props.selectedDataById.actualStartDate).format("MMM DD, YYYY HH:mm a")) &&
                                < Popup
                                    className="popupStyledWhite"
                                    trigger={<Icon name="info circle" />}
                                    flowing
                                    hoverable
                                >
                                    Actual Start Date <br />
                                    {this.props.selectedDataById.actualStartDate ? momentDateAndTime(this.props.selectedDataById.actualStartDate) : momentDateAndTime()}
                                </Popup>
                            }

                        </Grid.Column>
                        <Grid.Column width={4} className="pad_0 text-right">
                            {calculateProgress === 0 ? 0 : <label>{calculateProgress === null ? 0 : isNaN(calculateProgress) ? 0 : calculateProgress} <Icon name="percent" className="f_10" /></label>}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row style={{ padding: '10px 0px 0 0' }} onMouseEnter={() => dispatch.app.setHelpContext("Progress Bar")}>
                        <div className="overallProgress">
                            <Progress completed={calculateProgress === 0 ? 0 : Number(calculateProgress) ? Number(calculateProgress) : 0} />
                        </div>
                    </Grid.Row>
                    <Grid.Row style={{ padding: "10px 0 0 0" }}>
                        <ProgressCard
                            {...this.props}
                            activityNodes={this.props.selectedDataById.activityNodes}
                            isLoadingData={this.props.isLoadingData} />

                    </Grid.Row>
                </Grid>

            </div>

        );
    }
}


export default withRouter(WorkProgress);
